import { render, staticRenderFns } from "./nursePresAddWy.vue?vue&type=template&id=d863f6ee"
import script from "./nursePresAddWy.vue?vue&type=script&lang=ts"
export * from "./nursePresAddWy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports